import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import logo from "../images/TP-_logo-orizz-claim-color.png";

function BasicExample() {
  const [sortedClientiData, setSortedClientiData] = useState([]);
  const [error, setError] = useState("");
  const [isError, setIsError] = useState(false);

  const [sortConfig, setSortConfig] = useState({
    key: "valore",
    direction: "descending",
  });

  const [showModal, setShowModal] = useState(false);
  const [selectedCliente, setSelectedCliente] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("mancata_vendita_dashboard.json");

        if (!res.data?.TP?.localita) {
          setError("Dati non validi");
          return;
        }

        const clientiData = res.data.TP.localita || [];
        const lastMinuti = res.data.TP.lastminuti || [];

        /* ===============================
           1️⃣ FILTRO LAST MINUTE DEL GIORNO CORRENTE
        =============================== */

        const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD

        // trasformo lastMinuti in mappa per lookup veloce
        const expressMap = lastMinuti.reduce((acc, lm) => {
          if (!lm.ordinato) return acc; // skip null

          const dataOrdine = lm.data_ordine?.split(" ")[0]; // YYYY-MM-DD
          if (dataOrdine !== today) return acc; // solo oggi

          const key = `${lm.codice_cliente}-${lm.origine || "noweb"}`;
          const valore = parseFloat(lm.ordinato.replace(",", ".")) || 0;

          acc[key] = (acc[key] || 0) + valore;
          return acc;
        }, {});

        /* ===============================
           2️⃣ COSTRUISCO CLIENTI
        =============================== */

        const transformedData = clientiData.reduce((acc, item) => {
          const id = item.id_cliente;
          const origine = item.origine || "noweb";
          const key = `${id}-${origine}`;

          const valore = parseFloat(item.Valore?.replace(",", ".")) || 0;

          if (!acc[key]) {
            acc[key] = {
              id_cliente: id,
              cliente: item.clienti,
              valore: 0,
              express: 0,
              regular: 0,
              numero: 0,
              localita: item.regione || item.nazione || item.paese,
              origine,
              dettagli: [],
            };
          }

          acc[key].valore += valore;
          acc[key].numero += Number(item.numero_doc || 0);

          acc[key].dettagli.push({
            brand: item.brand,
            valore: valore,
          });

          return acc;
        }, {});

        /* ===============================
           3️⃣ AGGIUNGO EXPRESS E CALCOLO REGULAR
        =============================== */

        Object.values(transformedData).forEach((cliente) => {
          const key = `${cliente.id_cliente}-${cliente.origine}`;
          const express = expressMap[key] || 0;

          cliente.express = Math.min(express, cliente.valore); // sicurezza
          cliente.regular = cliente.valore - cliente.express;
        });

        /* ===============================
           4️⃣ ORDINO
        =============================== */

        const sortedData = sortArray(
          Object.values(transformedData),
          sortConfig.key,
          sortConfig.direction
        );

        setSortedClientiData(sortedData);
      } catch (err) {
        console.error(err);
        setIsError(true);
        setError(err.message);
      }
    };

    fetchData();
  }, [sortConfig]);

  const sortArray = (array, key, direction) => {
    return [...array].sort((a, b) => {
      const aValue = a[key] ?? 0;
      const bValue = b[key] ?? 0;

      if (typeof aValue === "number" && typeof bValue === "number") {
        return direction === "ascending"
          ? aValue - bValue
          : bValue - aValue;
      }

      return direction === "ascending"
        ? String(aValue).localeCompare(String(bValue))
        : String(bValue).localeCompare(String(aValue));
    });
  };

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const formatToEuro = (amount) =>
    new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
    }).format(amount || 0);

  const handleShowModal = (cliente) => {
    setSelectedCliente(cliente);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedCliente(null);
  };

  return (
    <div
      className="bg-light widget-client2 ombra tb hover-effect"
      style={{ borderRadius: "10px", border: "1px solid rgb(200,200,200)" }}
    >
      <Table variant="secondary" style={{ fontSize: "0.8rem" }}>
        <thead>
          <tr>
            <th className="bg-dark text-light">Clienti</th>
            <th
              className="bg-dark text-light"
              onClick={() => handleSort("localita")}
            >
              Località
            </th>
            <th
              className="bg-dark text-light"
              style={{ cursor: "pointer" }}
              onClick={() => handleSort("valore")}
            >
              Valore
            </th>
            <th
              className="bg-dark text-light"
              style={{ cursor: "pointer" }}
              onClick={() => handleSort("express")}
            >
              Last Minute
            </th>
            <th
              className="bg-dark text-light"
              style={{ cursor: "pointer" }}
              onClick={() => handleSort("regular")}
            >
              Regular
            </th>
            <th className="bg-dark text-light">Numero</th>
            <th className="bg-dark text-light">Origine</th>
          </tr>
        </thead>

        <tbody>
          {sortedClientiData.map((item, index) => (
            <tr key={index} onClick={() => handleShowModal(item)}>
              <td>{item.cliente}</td>
              <td>{item.localita}</td>
              <td className="fw-bold">{formatToEuro(item.valore)}</td>
              <td>{formatToEuro(item.express)}</td>
              <td>{formatToEuro(item.regular)}</td>
              <td>{item.numero}</td>
              <td>{item.origine}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Modal
        className="p-5"
        style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
        show={showModal}
        onHide={handleCloseModal}
        centered
      >
        <Modal.Header className="d-flex justify-content-center align-item-center text-light">
          <Modal.Title className="text-title">
            <p>{selectedCliente?.cliente}</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedCliente?.dettagli.map((dettaglio, dettaglioIndex) => (
            <p className="text-center text-dark fs-4" key={dettaglioIndex}>
              <span className="fw-bold">{dettaglio.brand}: </span>
              {formatToEuro(dettaglio.valore)}
            </p>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <img
            src={logo}
            alt=""
            className="mx-auto p-2"
            style={{ width: "200px" }}
          />
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default BasicExample;
